import { Grid } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { CloudOutlined, LocalShippingOutlined } from '@material-ui/icons';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import TopPage from 'v2/components/Shared/TopPage';
import { EProductType } from 'v2/interfaces/product';

import { ButtonRedirect } from './ButtonRedirect';

import type { DispatchProp } from 'react-redux';

function DesignServicesIcon() {
  return (
    <svg focusable='false' aria-hidden='true' viewBox='0 0 24 24' data-testid='DesignServicesIcon' style={{ width: 35 }}>
      <path d='m16.24 11.51 1.57-1.57-3.75-3.75-1.57 1.57-4.14-4.13c-.78-.78-2.05-.78-2.83 0l-1.9 1.9c-.78.78-.78 2.05 0 2.83l4.13 4.13L3 17.25V21h3.75l4.76-4.76 4.13 4.13c.95.95 2.23.6 2.83 0l1.9-1.9c.78-.78.78-2.05 0-2.83l-4.13-4.13zm-7.06-.44L5.04 6.94l1.89-1.9L8.2 6.31 7.02 7.5l1.41 1.41 1.19-1.19 1.45 1.45-1.89 1.9zm7.88 7.89-4.13-4.13 1.9-1.9 1.45 1.45-1.19 1.19 1.41 1.41 1.19-1.19 1.27 1.27-1.9 1.9zm3.65-11.92c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.47-.47-1.12-.29-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'></path>
    </svg>
  );
}

const products = [
  {
    name: 'MyEduzz Digital',
    title: 'Digital',
    subtitle: 'E-books, cursos online, planilhas...',
    icon: <CloudOutlined style={{ fontSize: 35 }} />,
    type: EProductType.DIGITAL,
    id: 'new-info-product-button',
  },
  {
    name: 'MyEduzz Físico',
    title: 'Físico',
    subtitle: 'Livros e apostilas',
    icon: <LocalShippingOutlined style={{ fontSize: 35 }} />,
    type: EProductType.PHYSICAL,
    id: 'new-physical-product-button',
  },
  {
    name: 'MyEduzz Serviço',
    description: 'Lá você vai encontrar tudo para criar e gerenciar seus serviços.',
    icon: <DesignServicesIcon />,
    title: 'Serviço Online',
    subtitle: 'Consultorias, Mentorias, Coaching...',
    type: EProductType.SERVICE,
    id: 'new-jobzz-product-button',
  },
  {
    name: 'Blinket',
    logo: '/img/blinket-symbol.svg',
    logoWidth: 35,
    description: 'Lá você vai encontrar tudo para criar e gerenciar seus eventos.',
    whyLink: 'https://ajuda.eduzz.com/?article=como-funciona-a-plataforma-blinket',
    whyLabel: 'a Blinket',
    color: '#ED1A62',
    redirect: 'https://app.blinket.com.br/event?utm_source=orbita&utm_medium=newproduct',
    title: 'Eventos',
    subtitle: 'Congressos, workshops, shows...',
    type: EProductType.TICKET,
    id: 'new-blinket-product-button',
  },
];

interface IProps extends DispatchProp<any> {}

class StepOne extends React.Component<IProps> {
  onChooseType = async (selected: (typeof products)[0]) => {
    if (selected.type === EProductType.TICKET) {
      window.open(selected.redirect, '_blank');
      return;
    }
    try {
      await this.props.dispatch({ type: 'SET_VALUE_WIZARD_NP', value: selected.type });
      this.props.dispatch({ type: 'NEXT_STEP_WIZARD_NP' });
      const currentUrl = window.location.href;
      if (selected.type === EProductType.DIGITAL) window.history.replaceState(null, null, `${currentUrl}/digital`);
      if (selected.type === EProductType.PHYSICAL) window.history.replaceState(null, null, `${currentUrl}/physical`);
      if (selected.type === EProductType.SERVICE) window.history.replaceState(null, null, `${currentUrl}/service`);
    } catch (error) {}
  };

  render() {
    return (
      <div>
        <Grid container spacing={2} style={{ marginBottom: 16 }}>
          <Grid item xs={12}>
            <Breadcrumbs aria-label='breadcrumb'>
              <Link to='/producer/product/myproducts'>Meus Produtos</Link>
              <p>Tipo de produto</p>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <TopPage title='Criar Novo Produto' />

        <Grid container spacing={2}>
          {products.map((p) => (
            <Grid item lg={3} md={6} xs={12} key={p.name}>
              <ButtonRedirect
                id={p.id}
                name={p.name}
                title={p.title}
                subtitle={p.subtitle}
                logo={p.logo}
                icon={p.icon}
                onClick={() => this.onChooseType(p)}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    );
  }
}

export default connect()(StepOne);
